<template>
  <div>
    <MaintenanceAlert v-if="hasMaintenanceAirWallex" />
    <div v-else>
      <div v-if="detailInfo">
        <div :class=" hasStepGuide ? 'in-process-step-guide' : 'top-up-in-process'">
          <top-up-success
            class="summary-form"
            :detail-info="detailInfo"
            :amount="detailInfo.amount"
            :transfer="{value: detailInfo.coinNetwork}"
            :coin-type="detailInfo.coinType"
            :payment-method="{value: detailInfo.coinType, paymentMethod: detailInfo.paymentMethod}"
          />
        </div>
        <div
          class="user-hint mt-1 mb-2 d-flex"
          :class="hasStepGuide ? '' : 'justify-content-center'"
        >
          <user-hint :class="showUserGuide ? 'd-lg-none' : ''" />
        </div>
      </div>
      <div
        v-else-if="!showConfirmation"
        class="width-content mb-2"
      >
        <b-row class="add-fund-container mx-0">
        <b-col
          :md="hasStepGuide ? 12 : 9"
          class="card-content p-0"
        >
          <div
            class="airwallex-payment-info"
            @mouseover="showGuideDefault = false"
            @mouseleave="showGuideDefault = true"
          >
            <payment-infor
              :method="paymentMethod"
              :transfer="transferNetwork"
              :options="airwallexAccounts"
              @on-change="handleChangeMethod"
              @on-change-transfer="handleChangeTransferNetwork"
            />
          </div>
        </b-col>

        <b-col
          :md="hasStepGuide ? 12 : 9"
          class="mt-2 p-0 card-content"
        >
          <div
            class="airwallex-top-up-amount"
            @mouseover="showGuideDefault = false"
            @mouseleave="showGuideDefault = true"
          >
            <top-up-amount
              :payment-method="paymentMethod"
              :transfer="transferNetwork"
              :amount="amount"
              :amount-tip="amountTip"
              :tip-index="tipIndex"
              :percentage-tip="percentageTip"
              :show-tips-input="showTipsInput"
              @on-confirm="handleShowConfirm"
            />
          </div>
        </b-col>
      </b-row>
      <div class="user-hint mt-1 mb-2 d-flex">
        <user-hint :class="showUserGuide ? 'd-lg-none' : ''" />
      </div>
    </div>
    <div v-else>
      <b-row class="row w-100 width-content add-fund-container">
        <b-col
          :md="hasStepGuide ? 12 : 9"
          class="card-content p-0"
        >
          <div
            class="airwallex-payment-info"
            @mouseover="showGuideDefault = false"
            @mouseleave="showGuideDefault = true"
          >
            <payment-infor
              v-if="!isShowSuccessPage && isAddFundView"
              :method="paymentMethod"
              :transfer="transferNetwork"
              :options="airwallexAccounts"
              @on-change="handleChangeMethod"
              @on-change-transfer="handleChangeTransferNetwork"
            />
          </div>
        </b-col>
        <b-col
          :md="hasStepGuide ? 12 : 9"
          class="mt-2 p-0 card-content"
        >
          <div
            class="airwallex-confirm-amount"
            @mouseover="showGuideDefault = false"
            @mouseleave="showGuideDefault = true"
          >
            <!-- :is-toggle="isToggle" -->
            <confirm-amount
              :transaction-info="transactionInfo"
              :amount="amount"
              :account="account"
              :billing="billing"
              :payment-method="paymentMethod"
              :transfer="transferNetwork"
              :amount-tip="amountTip"
              :current-tip="percentageTip"
              :current-tip-index="tipIndex"
              :show-tips-input="showTipsInput"
              @on-prev="handlePrev"
              @handleShowSuccess="handleShowSuccess"
            />
          </div>
        </b-col>
      </b-row>
      <div class="user-hint mt-1 mb-2 d-flex">
        <user-hint :class="showUserGuide ? 'd-lg-none' : ''" />
      </div>
    </div>
  </div>
</div>
</template>

<script>
import { BRow, BCol } from 'bootstrap-vue'
import {
  BANK_ACCOUNTS, TRANSFER_NETWORKS, PAYMENT_METHOD, PAYMENT_GATE_STATUS,
} from '@/constants'
import envMixin from '@/mixins/envMixin'
import paymentMixin from '@/mixins/paymentMixin'
import { createNamespacedHelpers } from 'vuex'
import stepGuideMixin from '@/mixins/stepGuideMixin'
import MaintenanceAlert from '@/views/payment/components/MaintenanceAlert.vue'
import GeneralConfigsMixin from '@/mixins/generalConfigsMixin'
import GEMFlag from '@/assets/images/pages/payment/gem-flag.svg'
import USAFlag from '@/assets/images/pages/payment/usa-flag.png'
import UserHint from '@/components/UserHint.vue'
import PaymentInfor from './PaymentInfo.vue'
import TopUpAmount from './TopUpAmount.vue'
import ConfirmAmount from './ConfirmAmount.vue'
import TopUpSuccess from './TopUpSuccess.vue'

const { mapGetters } = createNamespacedHelpers('payment')
export default {
  components: {
    MaintenanceAlert,
    BRow,
    BCol,
    PaymentInfor,
    TopUpAmount,
    ConfirmAmount,
    TopUpSuccess,
    UserHint,
  },

  mixins: [envMixin, stepGuideMixin, paymentMixin, GeneralConfigsMixin],

  data() {
    return {
      paymentMethod: BANK_ACCOUNTS[0],
      transferNetwork: TRANSFER_NETWORKS[0],
      showConfirmation: false,
      amount: 0,
      account: {},
      // isToggle: null,
      transactionInfo: '',
      detailInfo: null,
      billing: [],
      showIntro: false,
      isShowSuccessPage: false,
      showGuideDefault: true,

      contentModal: {},
      airwallexPaymentModal: {
        title: 'How to add fund with Airwallex?',
        description: '',
        video: 'https://www.youtube.com/embed/OzTmJsdtl4I',
        guideURL: process.env.VUE_APP_GUIDE_TO_TOP_UP_AIRWALLET,
      },
      airwallexPaymentModalNoStep: {
        title: 'How to add fund with Airwallex?',
        description: '',
        video: 'https://www.youtube.com/embed/LkLu8PTagBM',
        guideURL: process.env.VUE_APP_GUIDE_TO_TOP_UP_AIRWALLET,
      },

      amountTip: null,
      tipIndex: 0,
      percentageTip: null,
      showTipsInput: false,
    }
  },
  computed: {
    ...mapGetters(['listTicket']),
    // showIntro() {
    //   return this.isEcomdyPlatform
    // },

    hasMaintenanceAirWallex() {
      return this.paymentInfo?.airWallex?.status === PAYMENT_GATE_STATUS.MAINTENANCE
    },

    isAddFundView() {
      return !this.showConfirmation
    },

    airwallexAccounts() {
      const airwallexInfo = this.paymentInfo?.airWallex?.info || []
      if (!airwallexInfo.length) return BANK_ACCOUNTS

      return airwallexInfo.map(item => {
        const info = item.additionalInfo
        let icon = ''
        if (info.bankLocation === 'United States' || info.bankLocation === 'United States of America') icon = USAFlag
        else if (info.bankLocation === 'Germany') icon = GEMFlag

        return {
          ...info,
          type: 'airwallex',
          value: 'USD',
          name: info.bankLocation,
          icon,
        }
      })
    },
  },

  watch: {
    listTicket: {
      handler(val) {
        if (val) {
          const itemDetail = val?.content?.find(item => item?.details?.paymentMethod === PAYMENT_METHOD.AIRWALLEX && item.status === 'opening')
          this.detailInfo = itemDetail?.details
        }
      },
      deep: true,
      immediate: true,
    },
    showConfirmation(val) {
      if (this.$route.query.tab === 'airwallex') {
        this.$emit('on-toggle-payment-info', val)
      } else {
        this.$emit('on-toggle-payment-info', false)
      }
    },
    $route(to) {
      if (to.query.tab === 'airwallex' && this.showConfirmation) {
        this.$emit('on-toggle-payment-info', true)
      }
    },
  },

  methods: {
    handleChangeMethod(method) {
      this.paymentMethod = method
    },

    handleChangeTransferNetwork(transfer) {
      this.transferNetwork = transfer
    },

    handleShowConfirm(data) {
      this.showConfirmation = true
      this.amount = data.amount
      this.account = data.account
      // this.isToggle = data.isToggle
      this.amountTip = data.tipAMAmount
      this.percentageTip = data.currentTip
      this.tipIndex = data.currentTipIndex
      this.showTipsInput = data.showTipsForAM
    },

    handlePrev(data) {
      this.showConfirmation = false
      this.amount = data.amount
      this.transactionInfo = data.transactionId
      this.billing = data.billing
      this.amountTip = data.amountTip
      this.percentageTip = data.currentTip
      this.tipIndex = data.currentTipIndex
      this.showTipsInput = data.showTipsForAM
    },

    handleShowSuccess(data) {
      this.isShowSuccessPage = data
      this.$emit('handleShowSuccessTabs', this.isShowSuccessPage)
    },

    goToAirGuide() {
      window.open(process.env.VUE_APP_GUIDE_TO_TOP_UP_AIRWALLET)
    },
  },
}
</script>
<style lang="scss">

.horizontal-divide{
  width: 1px;
  height: 100%;
  background: #EEEEEE;
}

.info-box{
  position: absolute;
  top: -23px;
  right: 3px;
  font-size: .875rem;
  .icon-info{
    margin-left: 4px;
  }
}

.mrb-10 {
  margin-bottom: 10px;
}

.top-up-in-process {
  max-width: 410px;
  margin: 0 auto;
  margin-top: 42px;
}

.width-content {
  max-width: 1200px;
  margin: 0px auto;

  @media (max-width: 992px){
    justify-content: center;
  }
}

.card-content{
  @media (max-width: 1399px){
    max-width: 719px;
  }
}

.guide-video {
  position: absolute;
  top: 19px;
  left: 20px;
  color: #4CB375;
}

.guide-icon {
  top: 19px;
  right: 12px;
}

.airwallex-payment-info:hover .tooltip-airwallex-payment-info {
  @media (min-width: 768px) {
    display: block;
  }
}
.airwallex-top-up-amount:hover .tooltip-airwallex-top-up-amount {
  @media (min-width: 768px) {
    display: block;
  }
}
.airwallex-confirm-amount:hover .tooltip-airwallex-confirm-amount {
  @media (min-width: 768px) {
    display: block;
  }
}
</style>
<style lang="scss" scoped>
  .warning-message {
    margin-top: 10px;
    background: rgba(251, 176, 59, 0.1);
    border-radius: 10px;
    padding: 10px 12px 10px 16px;
  }
</style>
